import React, { createContext, useContext, useMemo } from 'react'

interface DevToolsContextValue {
  userEmail?: string | null
}

const DevToolsContext = createContext<DevToolsContextValue>({})

interface DevToolsProviderProps {
  userEmail?: string | null
  children: React.ReactNode
}

export function DevToolsProvider({ userEmail, children }: DevToolsProviderProps) {
  const value = useMemo(() => ({ userEmail }), [userEmail])
  return <DevToolsContext.Provider value={value}>{children}</DevToolsContext.Provider>
}

export function useDevTools() {
  return useContext(DevToolsContext)
}

/**
 * DEV 모드: 항상 표시
 * Staging (VITE_ENABLE_DEV_TOOLS=true): @quebon.com 이메일만 표시
 */
export function isDevToolsVisible(userEmail?: string | null): boolean {
  const isDev = import.meta.env.DEV
  const isEnableDevTools = import.meta.env.VITE_ENABLE_DEV_TOOLS === 'true'
  return isDev || (isEnableDevTools && !!userEmail?.endsWith('@quebon.com'))
}
